
(function ($) { 
    
    Drupal.behaviors.artistProfile = {

        attach: function (context) {
            Drupal.behaviors.functions.consolog("drupal init artistProfile");

            $(".artistProfile", context).each(function (index){   
            		var mainContent = $(this);
                //init only in deeplink to profile
                if($(".virtualMuseum").length == 0){
                	$(".artistProfile", context).data("original-title",document.title);
                    //set click listener for gallery teaser
                    $(this).find(".artistGalleryTeaserImage").click(function(){
                        var userid = $(this).attr("data-user-id");
                        var traceid = $(this).parent(".artistGalleryTeaser").attr("data-trace-id");
                        loadArtistGalleryPage(traceid, userid);  
                    });
                    $(this).find(".artistGalleryTeaserLink").click(function(){
                        var userid = $(this).attr("data-user-id");
                        var traceid = $(this).parent(".artistGalleryTeaser").attr("data-trace-id");
                        loadArtistGalleryPage(traceid, userid);  
                    });
                }
                
                //Setup modal videos click
                /*
	  	    	  	$(".videoOverlay",mainContent).swipe( {
		    		    //Generic swipe handler for all directions
		    		    tap:function() {
		    		    	Drupal.behaviors.functions.consolog("Tap on videooverlay artist profile");
	                		$("#artistProfileVideoModal",mainContent).data("video-identifier", $(this).data("video-identifier"));
	                		$("#artistProfileVideoModal",mainContent).data("video-type", $(this).data("video-type"));
	                		$("#artistProfileVideoModal",mainContent).modal("show");
		    		    },
		    	  		threshold: 10
	  	    	  	});
	  	    	  	*/
                
                //Artist profile video modal
                $(".videoOverlay",mainContent).click(function(){
	            		$("#artistProfileVideoModal").data("video-identifier", $(this).data("video-identifier"));
	            		$("#artistProfileVideoModal").data("video-type", $(this).data("video-type"));
	            		$("#artistProfileVideoModal").modal("show");
                });
                
                //Wechat
                $(".weChatModalCaller",mainContent).click(function(){
	            		$("#artistProfileWeChat").data("wechat-image", $(this).data("wechat-image"));
	            		$("#artistProfileWeChat").modal("show");
                });
            });

            function loadArtistGalleryPage(traceid, userid){

				if(!traceid){
					return;
				}

                Drupal.behaviors.functions.consolog("show artist gallery # trace:" + traceid + " userid:" + userid);
                var codepath = $(".artistProfile").attr("data-url-gallery");
                codepath = codepath.replace("%7Bid%7D", traceid);                

                $(".preloader").show();

                $("<div></div>").load(codepath, function(response, status, xhr) {

                    if ( status == "error" ) {
                        $(".preloader").hide();
                        return;
                    }
                    
        			//When is loaded switch the title
        			$(document).prop('title', $("title", this).text());  

                    $("#artistProfileGalleryOverlay").removeClass("active");                    

                    $("#artistProfileGalleryOverlay").html($(this).find(".artistGallery"));
                    $(this).empty();

                    $("#artistProfileGalleryOverlay").children(".artistGallery").css("opacity", 0);                    
                    $("#artistProfileGalleryOverlay").show();

                    $(".preloader").hide();

                    $("#artistProfileGalleryOverlay").children(".artistGallery").fadeTo(500, 1, function() {                      
                        $("#artistProfileGalleryOverlay").addClass("active");
                    });
                    
                    Drupal.behaviors.iconCreator($(".artistGallery"));
                    Drupal.behaviors.linkButtonCreator($(".artistGallery"));
                    Drupal.behaviors.artistGallery.initSlider();      
                    
                    /*
                    setTimeout(function(){
                        Drupal.behaviors.artistGallery.updateSlider();               
                    }, 1000);
                    */
                    
                    $("#artistProfileGalleryOverlay").find(".artistGallery").click(function(event){
                    
                        var target = $(event.target);
                        if(target.is("img") || target.parents(".artistGalleryContentContainer").length > 0 || target.parents(".artistGalleryNavigation").length > 0 || target.parents(".artistGalleryFooter").length > 0){
                            //do not close!
                        }
                        else{                        
                            closeGalleryPage(); 
                        }
                                        
                    });

                    $("#artistProfileGalleryOverlay").find(".artistProfileButton").click(function(e){
                        e.preventDefault();          
                        closeGalleryPage();
                    });

                    $("#artistProfileGalleryOverlay").find(".artistGalleryText .linkButton").click(function(e){
                        e.preventDefault();          
                        closeGalleryPage();
                    });

                    $("#artistProfileGalleryOverlay").find(".artistGalleryClosebutton").click(function(e){
                        e.preventDefault();
                        closeGalleryPage();
                    });

                    $(document).unbind().scroll(function() {
                        if($(".slick-current").find("iframe").length > 0 && $(".slick-current").find("iframe").attr("src") != ""){
                            //do not listen to scroll listner if video is active
                        }
                        else{
                            $(document).unbind();
                            closeGalleryPage();  
                        }             
                    });
                });
            }

            function closeGalleryPage(){
            	$(document).prop('title', $(".artistProfile", context).data("original-title"));
                $("#artistProfileGalleryOverlay").removeClass("active");        
                $("#artistProfileGalleryOverlay").fadeOut(500, function(){
                    $("#artistProfileGalleryOverlay").hide();
                });  
                
                if($("#artistProfileGalleryOverlay").find("iframe").length > 0){
                    $(".artistGalleryImageSliderPage").removeClass("showVideo");
                    $(".artistGalleryImageSliderPage").find("iframe").attr("src", "");
                }
            }
        }
    };


})(jQuery);
